var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Button, Card, Select, Table } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { fetchUserPrefectureDistribution, fetchUserRegionDistribution } from '../../cores/api/api-dashboard';
import { formatCountNumber } from '../../utils/format-data';
const REGION_LABEL_ORDER = ['北海道', '東北', '関東', '中部', '関西', '中国', '四国', '九州'];
const SEGMENT_ORDER_BY_MACRO = {
    北海道: ['北海道（札幌）', '北海道（道東）', '北海道（道南）', '北海道（道北）', '北海道（道央）'],
    東北: ['青森県', '岩手県', '秋田県', '山形県', '宮城県', '福島県'],
    関東: ['栃木県', '茨城県', '群馬県', '千葉県', '埼玉県', '東京都', '神奈川県'],
    中部: ['山梨県', '新潟県', '長野県', '富山県', '石川県', '福井県', '静岡県', '愛知県', '岐阜県'],
    関西: ['三重県', '滋賀県', '奈良県', '京都府', '大阪府', '和歌山県', '兵庫県'],
    中国: ['岡山県', '広島県', '鳥取県', '島根県', '山口県'],
    四国: ['香川県', '徳島県', '高知県', '愛媛県'],
    九州: ['福岡県', '長崎県', '佐賀県', '大分県', '熊本県', '宮崎県', '鹿児島県', '沖縄県']
};
function isFlatGenderStat(v) {
    if (!v || typeof v !== 'object')
        return false;
    const o = v;
    return typeof o.male === 'number' && typeof o.female === 'number' && Object.keys(o).every(k => k === 'male' || k === 'female');
}
function orderedSegmentRows(macro, segments) {
    if (!segments || isFlatGenderStat(segments))
        return [];
    const order = SEGMENT_ORDER_BY_MACRO[macro] || [];
    const seen = new Set();
    const rows = [];
    order.forEach(seg => {
        const gs = segments[seg];
        if (!gs)
            return;
        seen.add(seg);
        rows.push({
            key: seg,
            segment: seg,
            male: gs.male,
            female: gs.female,
            total: gs.male + gs.female
        });
    });
    Object.keys(segments).forEach(seg => {
        if (seen.has(seg))
            return;
        const gs = segments[seg];
        if (!isFlatGenderStat(gs))
            return;
        rows.push({
            key: seg,
            segment: seg,
            male: gs.male,
            female: gs.female,
            total: gs.male + gs.female
        });
    });
    return rows;
}
function regionDistributionApiToChartState(apiData) {
    if (!apiData) {
        return {
            labels: [],
            male: [],
            female: []
        };
    }
    const labels = [...REGION_LABEL_ORDER];
    return {
        labels,
        male: labels.map(r => { var _a, _b; return (_b = (_a = apiData[r]) === null || _a === void 0 ? void 0 : _a.male) !== null && _b !== void 0 ? _b : 0; }),
        female: labels.map(r => { var _a, _b; return (_b = (_a = apiData[r]) === null || _a === void 0 ? void 0 : _a.female) !== null && _b !== void 0 ? _b : 0; })
    };
}
function snapshotToChartStateForRegion(snap, regionScope) {
    if (!snap) {
        return {
            labels: [],
            male: [],
            female: []
        };
    }
    const rows = orderedSegmentRows(regionScope, snap[regionScope]);
    return {
        labels: rows.map(r => r.segment),
        male: rows.map(r => r.male),
        female: rows.map(r => r.female)
    };
}
const tableColumns = [{
        title: '地域',
        dataIndex: 'region',
        key: 'region'
    }, {
        title: '男性ユーザー',
        dataIndex: 'male',
        key: 'male',
        render: v => formatCountNumber(v)
    }, {
        title: '女性ユーザー',
        dataIndex: 'female',
        key: 'female',
        render: v => formatCountNumber(v)
    }, {
        title: '合計',
        dataIndex: 'total',
        key: 'total',
        render: v => formatCountNumber(v)
    }];
export const ChartPrefectureDistribution = () => {
    const _useState = useState('chart'), _useState2 = _slicedToArray(_useState, 2), viewMode = _useState2[0], setViewMode = _useState2[1];
    const _useState3 = useState(), _useState4 = _slicedToArray(_useState3, 2), gender = _useState4[0], setGender = _useState4[1];
    const _useState5 = useState('all'), _useState6 = _slicedToArray(_useState5, 2), regionScope = _useState6[0], setRegionScope = _useState6[1];
    const _useQuery = useQuery({
        queryKey: ['user-prefecture-distribution', regionScope, gender],
        suspense: true,
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            if (regionScope === 'all') {
                const res = yield fetchUserRegionDistribution({
                    gender
                });
                return regionDistributionApiToChartState(res === null || res === void 0 ? void 0 : res.data);
            }
            const res = yield fetchUserPrefectureDistribution({
                gender,
                region: regionScope
            });
            const raw = res === null || res === void 0 ? void 0 : res.data;
            if (!raw) {
                return {
                    labels: [],
                    male: [],
                    female: []
                };
            }
            return snapshotToChartStateForRegion(raw, regionScope);
        }),
        staleTime: 1000 * 60 * 5
    }), chartState = _useQuery.data;
    const resolvedChart = chartState !== null && chartState !== void 0 ? chartState : {
        labels: [],
        male: [],
        female: []
    };
    const chartData = {
        labels: resolvedChart.labels,
        datasets: [...(gender !== 'female' ? [{
                    label: '男性',
                    data: resolvedChart.male,
                    backgroundColor: '#1890ff',
                    minBarLength: 20
                }] : []), ...(gender !== 'male' ? [{
                    label: '女性',
                    data: resolvedChart.female,
                    backgroundColor: '#ff4d4f',
                    minBarLength: 20
                }] : [])]
    };
    const chartOptions = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false
    };
    const tableData = resolvedChart.labels.map((label, index) => ({
        key: label,
        region: label,
        male: resolvedChart.male[index],
        female: resolvedChart.female[index],
        total: resolvedChart.male[index] + resolvedChart.female[index]
    }));
    return /*#__PURE__*/ React.createElement(Card, {
        title: "\u7537\u5973\u5225\u6D3B\u52D5\u7BC4\u56F2\u30E6\u30FC\u30B6\u30FC\u5206\u5E03",
        extra: /*#__PURE__*/ React.createElement("div", {
            className: "flex flex-wrap items-center gap-4 justify-end"
        }, /*#__PURE__*/ React.createElement(Select, {
            style: {
                minWidth: 120
            },
            value: regionScope,
            onChange: v => setRegionScope(v),
            options: [{
                    label: '全国',
                    value: 'all'
                }, ...REGION_LABEL_ORDER.map(r => ({
                    label: r,
                    value: r
                }))]
        }), /*#__PURE__*/ React.createElement(Select, {
            style: {
                minWidth: 100
            },
            value: gender !== null && gender !== void 0 ? gender : 'all',
            onChange: v => setGender(v === 'all' ? undefined : v),
            options: [{
                    label: '全体',
                    value: 'all'
                }, {
                    label: '男性',
                    value: 'male'
                }, {
                    label: '女性',
                    value: 'female'
                }]
        }), /*#__PURE__*/ React.createElement("div", {
            className: "flex gap-2"
        }, /*#__PURE__*/ React.createElement(Button, {
            onClick: () => setViewMode('chart'),
            className: viewMode === 'chart' ? '!bg-[#f0c52a36]' : ''
        }, "\u30B0\u30E9\u30D5"), /*#__PURE__*/ React.createElement(Button, {
            onClick: () => setViewMode('table'),
            className: viewMode === 'table' ? '!bg-[#f0c52a36]' : ''
        }, "\u8868"))),
        styles: {
            body: {
                paddingTop: '4px',
                height: 570
            }
        }
    }, viewMode === 'chart' ? /*#__PURE__*/ React.createElement("div", {
        style: {
            height: 550
        }
    }, /*#__PURE__*/ React.createElement(Bar, {
        data: chartData,
        options: chartOptions
    })) : /*#__PURE__*/ React.createElement(Table, {
        rowKey: "key",
        columns: tableColumns,
        dataSource: tableData,
        pagination: false,
        scroll: {
            y: 400
        },
        locale: {
            emptyText: 'データがありません'
        }
    }));
};
